"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationModule = void 0;
var OrganizationModule = /** @class */ (function () {
    function OrganizationModule(xhr) {
        this.xhr = xhr;
    }
    /**
     * Get current user's organization
     * @returns resolves with current user's organization
     */
    OrganizationModule.prototype.getCurrentOrganization = function () {
        return this.xhr.getParsed("/gdc/app/organization/current");
    };
    return OrganizationModule;
}());
exports.OrganizationModule = OrganizationModule;
//# sourceMappingURL=organization.js.map